import { IDropdownOption } from 'features/common/types';

export const defaultCategoryOption: IDropdownOption = {
    label: 'None',
    value: '',
};
